import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
interface Breadcrumb {
  label: string;
  href?: string;
}
interface PageHeaderProps {
  title: string;
  breadcrumbs?: Breadcrumb[];
  children?: React.ReactNode;
}
export function PageHeader({ title, breadcrumbs, children }: PageHeaderProps) {
  return (
    <div className="mb-6">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav className="flex items-center gap-1 font-mono text-2xs uppercase tracking-wider text-muted-foreground mb-2">
          {breadcrumbs.map((crumb, i) => (
            <React.Fragment key={i}>
              {i > 0 && <ChevronRight className="h-3 w-3" />}
              {crumb.href ? (
                <Link
                  to={crumb.href}
                  className="hover:text-foreground transition-colors"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-foreground">{crumb.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>
      )}
      <div className="flex items-center justify-between gap-4">
        {/* DM Serif Display per brand spec — page titles are display moments */}
        <h1 className="font-display text-3xl text-charcoal dark:text-charcoal-dark">{title}</h1>
        {children && <div className="flex items-center gap-2">{children}</div>}
      </div>
    </div>
  );
}